var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "col-md-12" }, [
      _c(
        "div",
        { staticStyle: { float: "right", margin: "10px -15px 10px  10px" } },
        [
          _c(
            "a",
            {
              staticClass: "btn command-action custom-action green",
              attrs: { id: "CMD_RATEIO" },
              on: {
                click: function ($event) {
                  return _vm.ratear()
                },
              },
            },
            [
              _c("i", { staticClass: "fa fa-calculator btn-action" }),
              _vm._v("\n        Ratear valores\n      "),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: this.qtdOrigem == this.qtdDestino,
                  expression: "this.qtdOrigem == this.qtdDestino",
                },
              ],
              staticClass: "btn command-action custom-action green-meadow",
              attrs: { id: "CMD_RATEIO" },
              on: {
                click: function ($event) {
                  return _vm.umPraUm()
                },
              },
            },
            [
              _c("i", { staticClass: "fa fa-arrows-h btn-action" }),
              _vm._v("\n        Um pra Um\n      "),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn command-action custom-action blue",
              attrs: { id: "CMD_REMANEJAR" },
              on: {
                click: function ($event) {
                  return _vm.remanejar()
                },
              },
            },
            [
              _c("i", { staticClass: "fa fa-exchange btn-action" }),
              _vm._v("\n        Salvar remanejamento\n      "),
            ]
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "col-md-6",
        staticStyle: {
          "border-right": "1px solid #dae2ea",
          "margin-right": "-1px",
        },
      },
      [
        _c("orcamento-remanejar-grid", {
          key: _vm.PegarChave(),
          attrs: {
            titulo: "Origem",
            labelValorTotal: "Total remanejado",
            valorTotal: _vm.origemTotalRemanejado,
            rows: _vm.obterOrigens(),
            desabilitarOrcadoNegativo: true,
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "col-md-6",
        staticStyle: { "border-left": "1px solid #dae2ea" },
      },
      [
        _c("orcamento-remanejar-grid", {
          key: _vm.PegarChave(),
          attrs: {
            titulo: "Destino",
            labelValorTotal: _vm.destinoLabelTotalRemanejado,
            classValorTotal: _vm.destinoClassTotalRemanejado,
            valorTotal: _vm.destinoTotalRemanejado,
            rows: _vm.obterDestinos(),
            validarMaximo: false,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }